import { ArrowDownRight, ArrowUpRight } from "lucide-react";

export default function KpiCard({
  title,
  value,
  subtitle,
  trend,
  accent = "neutral",
}) {
  const isUp = trend > 0;
  const isDown = trend < 0;

  const accentMap = {
    neutral: "admin-v2-text-strong",
    success: "admin-v2-text-accent",
    danger: "admin-v2-text-danger",
    info: "admin-v2-text-highlight",
  };

  return (
    <div className="tw-rounded-[22px] tw-p-4 sm:tw-p-5 tw-flex tw-flex-col tw-justify-between tw-bg-white/90 tw-border tw-border-[rgba(31,41,64,0.08)] tw-shadow-[0_16px_30px_rgba(31,41,64,0.06)] tw-min-h-[120px]">
      <p className="tw-text-[11px] tw-uppercase tw-tracking-[0.18em] admin-v2-text-muted tw-font-semibold">{title}</p>

      <div className="tw-mt-2 tw-flex tw-items-end tw-justify-between">
        <p className={`tw-text-3xl sm:tw-text-[2rem] tw-font-semibold tw-tracking-tight ${accentMap[accent]}`}>
          {value}
        </p>

        {typeof trend === "number" && (
          <div
            className={`tw-flex tw-items-center tw-text-xs ${
              isUp ? "admin-v2-text-accent" : isDown ? "admin-v2-text-danger" : "admin-v2-text-muted"
            }`}
          >
            {isUp && <ArrowUpRight size={14} />}
            {isDown && <ArrowDownRight size={14} />}
            <span className="tw-ml-1">{Math.abs(trend)}%</span>
          </div>
        )}
      </div>

      {subtitle && <p className="tw-mt-2 tw-text-xs admin-v2-text-muted">{subtitle}</p>}
    </div>
  );
}
